import { useCallback, useState } from "react";

/**
 * Hook for tracking newly added threads with animation
 */
export function useThreadNewTracking() {
  const [newlyAddedThreads, setNewlyAddedThreads] = useState(new Map());

  const markThreadAsNew = useCallback((threadId, title) => {
    setNewlyAddedThreads((prev) => {
      const newMap = new Map(prev);
      newMap.set(threadId, { timestamp: Date.now(), title });
      return newMap;
    });

    const baseAnimationDuration = Math.max((title?.length || 10) * 50, 1000);
    const animationDuration = baseAnimationDuration + 1000;

    setTimeout(() => {
      setNewlyAddedThreads((prev) => {
        const newMap = new Map(prev);
        newMap.delete(threadId);
        return newMap;
      });
    }, animationDuration);
  }, []);

  const isThreadNew = useCallback(
    (threadId) => {
      return newlyAddedThreads.has(threadId);
    },
    [newlyAddedThreads]
  );

  return {
    markThreadAsNew,
    isThreadNew,
  };
}
